import React, { createContext } from "react";

type MapToolContextValue = {
  onMapToolEnter: () => void;
};

export const MapToolContext = createContext<MapToolContextValue>({
  onMapToolEnter: () => {},
});

export const MapToolProvider = ({
  children,
  onFocusLost,
}: {
  children: React.ReactNode;
  onFocusLost: () => void;
}) => {
  return (
    <MapToolContext.Provider
      value={{
        onMapToolEnter: onFocusLost,
      }}
    >
      {children}
    </MapToolContext.Provider>
  );
};
